export const dateSorting = (array, key) => {
  let _asc = array.sort((a, b) => {
    let firstKey = a[key] ? new Date(a[key].seconds * 1000).getTime() : "";
    let secondKey = b[key] ? new Date(b[key].seconds * 1000).getTime() : "";
    if (firstKey < secondKey) {
      return -1;
    }
    if (firstKey > secondKey) {
      return 1;
    }
    return 0;
  });

  return _asc.reverse();
};
